<template>
	<div class="etiket">
		<div class="container">
			<header class="header">
				<router-link :to="{ name: 'Search', params: { lang: $route.params.lang, metod: 'e-ticket' } }" class="title">
					<i class="fa fa-chevron-left" aria-hidden="true"></i>
					{{ $t("backBtn") }}
				</router-link>
				<div class="lang">
					<router-link class="lang__item" :class="{ active: $route.params.lang === 'uz' }"
						:to="{ name: 'ETicket', params: { lang: 'uz' } }">
						<img class="img" :src="linkImg + '/img/041-uzbekistan.png'" alt="" />
					</router-link>
					<router-link class="lang__item" :class="{ active: $route.params.lang === 'ru' }"
						:to="{ name: 'ETicket', params: { lang: 'ru' } }">
						<img class="img" :src="linkImg + '/img/044-russia.png'" alt="" />
					</router-link>
					<router-link class="lang__item" :class="{ active: $route.params.lang === 'en' }"
						:to="{ name: 'ETicket', params: { lang: 'en' } }">
						<img class="img" :src="linkImg + '/img/186-united-states.png'" alt="" />
					</router-link>
				</div>
			</header>
			<div v-show="closeTimeActive" class="closeTimeActive">
				<h1>{{ $t("information") }}</h1>
				<p>{{ $t("closeText") }}</p>
			</div>
			<div v-show="openTimeActive" class="eticket">
				<h1 class="title-br">{{ $t("eTicket") }}</h1>
				<section class="booking-title">
					<h2>{{ filial.BranchName }}</h2>
					<p>{{ filial.BranchAddress }}</p>
				</section>
				<form class="card" @submit.prevent="openTicket" method="post">
					<div class="card__item">
						<div class="input modal-input" type="text" @click="open"
							:class="$v.eticketInfo.serviseText.$error ? 'is-invalid' : ''">
							<h1 class="modal-input__title">{{ $t("service") }}*</h1>
							<div class="modal-input__service">
								<p>{{ eticketInfo.serviseText }}</p>
								<i class="fa fa-caret-down" aria-hidden="true"></i>
							</div>
						</div>
						<div v-show="isActive" class="modal-inputSelect">
							<div class="modal-inputSelect__title">
								<h2>{{ $t("service") }}*</h2>
								<a href="/" class="close-link" @click.prevent="close()">
									<i class="fa fa-times" aria-hidden="true"></i>
								</a>
							</div>
							<ul>
								<li v-for="item in items" :key="item.ServiceId" class="item"
									:class="{ activeItem: liActive == item.ServiceId }" @click="liServiceActiveLink(item.ServiceId)">
									<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
									<p>{{ item.ServiceName }}</p>
								</li>
							</ul>
							<div class="modal-btn">
								<a href="" class="modal-btn__link" @click.prevent="showService()">ВЫБРАТЬ</a>
							</div>
						</div>
						<div v-show="isActive" class="modal-inputSelectBg"></div>
						<input class="input phone" :class="$v.eticketInfo.phone.$error ? 'is-invalid' : ''" type="tel"
							placeholder="+998" v-model.trim="$v.eticketInfo.phone.$model" />
					</div>
					<button type="submit" class="btn">{{ $t("receive") }}</button>
				</form>

				<div v-show="isActiveTicket" class="ticket">
					<h1 class="ticket__title">{{ $t("yourTicket") }}</h1>
					<ul>
						<li>
							<h1>{{ $t("number") }}</h1>
							<h2>{{ eticketInfo.number }}</h2>
						</li>
						<li>
							<h1>{{ $t("branch") }}</h1>
							<h2>{{ filial.BranchName }}</h2>
						</li>
						<li>
							<h1>{{ $t("address") }}</h1>
							<h2>{{ filial.BranchAddress }}</h2>
						</li>
						<li>
							<h1>{{ $t("service") }}</h1>
							<h2>{{ eticketInfo.serviseText }}</h2>
						</li>
						<li>
							<h1>{{ $t("validUntil") }}</h1>
							<!-- <h2>{{ eticketInfo.validUntil }} -->
							<h2>{{ eticketInfo.ValidUntil }}
							</h2>
						</li>
					</ul>
					<a href="" @click.prevent="deleteTicket(eticketInfo)" class="ticket__link">{{ $t("deleteBtnET") }}</a>
					<transition name="fade">
						<div v-if="isActiveToolTip" class="ticket__tooltip">
							<p>{{ $t("deteleText") }}</p>
						</div>
					</transition>
				</div>

				<div v-show="alertError" class="alertError">
					<p class="alertError__title">
						{{ $t("textAlready") }}
					</p>
					<a @click.prevent="closeAlertError()" href="" class="alertError__link">{{ $t("close") }}</a>
				</div>
				<div v-show="alertError" class="alertErrorBg"></div>
				<transition name="fade">
					<div v-show="alertActive" class="alert alertActive">
						<h1>{{ $t("failure") }}!</h1>
					</div>
				</transition>
			</div>
		</div>

		<Loading v-show="loading" />
	</div>
</template>

<script>
import axios from "axios"
// import Lang from "@/components/Lang.vue";
import Loading from "@/components/Loading.vue"
// import FingerprintJS from "@fingerprintjs/fingerprintjs"
import { osName } from "mobile-device-detect"
import "moment/locale/uz-latn"
import { maxLength, minLength, required } from "vuelidate/lib/validators"

export default {
	data() {
		return {
			language: this.$route.params.lang,
			liActive: "",
			eticketInfo: {
				serviseText: "",
				phone: "+998",
				number: "",
				date: {
					day: "",
					month: "",
					year: "",
				},
				deviceId: "",
				deviceType: "",
				ticketId: "",
				validUntil: ""
			},
			month: {
				0: "Январь",
				1: "Февраль",
				2: "Март",
				3: "Апрель",
				4: "Май",
				5: "Июнь",
				6: "Июль",
				7: "Август",
				8: "Сентябрь",
				9: "Октябрь",
				10: "Ноябрь",
				11: "Декабрь",
			},
			isActive: false,
			isActiveTicket: false,
			isActiveToolTip: false,
			alertError: false,
			alertActive: false,
			filial: [],
			serviceId: 0,
			loading: false,
			code: '',
			items: [],
			ticket: [],
			closeTimeActive: false,
			openTimeActive: false,
			linkImg: '',
			settings: '',
			deviceId: ''
		}
	},
	components: {
		Loading
	},
	beforeMount() {
		const deviceId = localStorage.getItem('deviceId')
		const deviceNumber = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
		if (deviceId == null || deviceId == undefined) {
			localStorage.setItem('deviceId', deviceNumber)
		} else if (deviceId != '') {
			this.deviceId = deviceId
		} else {
			this.deviceId = deviceNumber
			localStorage.setItem('deviceId', deviceNumber)
		}
		this.linkImg = window.MY_CONFIG_EASYQ.linkImg
	},
	mounted() {
		this.loading = true
		this.closeTime()
		this.loadOS()
		this.settings = window.MY_CONFIG_EASYQ
		this.$i18n.locale = this.$route.params.lang
		this.loadFilial()
		this.loadService()
		if (localStorage.eticket === null || localStorage.eticket === undefined) {
			localStorage.setItem("eticket", JSON.stringify([]))
		}
		this.loadDate()
	},
	methods: {
		loadOS() {
			if (osName === "Windows") {
				this.eticketInfo.deviceType = 3
			} else if (osName === " IOS") {
				this.eticketInfo.deviceType = 2
			} else if (osName === "Android") {
				this.eticketInfo.deviceType = 1
			} else {
				this.eticketInfo.deviceType = 0
			}
		},
		// loadnumber() {
		//   const fpPromise = FingerprintJS.load()
		//   const fp = await fpPromise
		//   const result = await fp.get()

		//   // This is the visitor identifier:
		//   const visitorId = result.visitorId
		//   this.eticketInfo.deviceId = visitorId
		//   // this.eticketInfo.deviceId = Math.floor(Math.random() * (4321 * 123456)) + 1;
		// },
		loadDate() {
			this.eticketInfo.date.day = new Date().getDate()
			this.eticketInfo.date.month = this.month[new Date().getMonth()]
			this.eticketInfo.date.year = new Date().getFullYear()
		},
		closeTime() {
			const time = new Date().getHours()

			if (time >= 9 && time <= 18) {
				this.openTimeActive = true
				this.closeTimeActive = false
			} else {
				this.closeTimeActive = true
				this.openTimeActive = false
			}
		},
		open() {
			this.isActive = true
		},
		close() {
			this.isActive = false
		},
		closeAlertError() {
			this.alertError = false
		},
		showService() {
			if (this.eticketInfo.serviseText === "") {
				this.isActive = false
			} else {
				const text = document.getElementsByTagName("ul")[0].querySelector("li.activeItem > p").textContent
				this.eticketInfo.serviseText = text
				this.isActive = false
			}
		},
		liServiceActiveLink(id) {
			this.serviceId = id
			this.liActive = id
			setTimeout(() => {
				this.eticketInfo.serviseText = document
					.getElementsByTagName("ul")[0]
					.querySelector("li.activeItem > p").textContent
			}, 100)
		},
		async loadService() {
			await axios
				.get(`${this.settings.apiBookingBarakaTexnika}/ListServices?BranchId=${this.$route.params.id}&languageShortId=${this.$route.params.lang}`)
				.then((response) => {
					this.items = response.data
					this.loading = false
				})
				.catch((error) => console.log(error))
		},
		async loadFilial() {
			await axios.get(`${this.settings.apiBookingBarakaTexnika}/Branches/ListBranches`)
				.then((response) => {
					// this.filialBarakaTexnika = response.data
					const fil = response.data
					fil.find((el) => {
						if (el.BranchId === +this.$route.params.id) {
							this.filial = el
						}
					})
				})
				.catch((error) => console.log(error))
		},
		openTicket() {
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.loadTicket()
				setTimeout(() => {
					if (this.code === -2) {
						this.alertError = true
						this.code = 0
					}
					else if (this.code === -1) {
						console.log(this.eticketInfo.Message);
					}
					else if (this.code === 1) {
						this.alertActive = true
						this.isActiveTicket = false
						setTimeout(() => {
							this.alertActive = false
						}, 2000)
					}
					else if (this.code === 0 && this.eticketInfo.number != null) {
						const eticket = {
							number: this.eticketInfo.number,
							branch: this.filial.BranchName,
							branchId: this.filial.BranchId,
							address: this.filial.BranchAddress,
							serviseText: this.eticketInfo.serviseText,
							serviceId: this.serviceId,
							phone: this.eticketInfo.phone,
							deviceId: this.deviceId,
							deviceType: this.eticketInfo.deviceType,
							day: this.eticketInfo.date.day,
							month: this.eticketInfo.date.month,
							year: this.eticketInfo.date.year,
							ticketId: this.eticketInfo.ticketId,
							validUntil: this.eticketInfo.validUntil
						}
						if (localStorage.eticket == [] || localStorage.eticket == null || localStorage.eticket == undefined) {
							localStorage.setItem("eticket", JSON.stringify(this.eticketInfo))
						} else {
							this.ticket = []
							const allEticket = JSON.parse(localStorage.eticket)
							///push в ticket
							for (let i = 0; i < allEticket.length; i++) {
								this.ticket.push(allEticket[i])
							}
							this.ticket.push(eticket)
							///clear localStorage
							localStorage.eticket = []
							/// запись в localStorage
							localStorage.eticket = JSON.stringify(this.ticket)
						}
						this.isActiveTicket = true
						this.code = 0
					} else {
						this.loading = false
					}
					setTimeout(() => {
						this.loading = false
					}, 3000)
				}, 6000)
			}
		},
		deleteTicket(info) {
			axios
				.post(`${this.settings.apiBookingBarakaTexnika}/E_Ticket/DeleteTicket?branchId=${this.$route.params.id}&number=${info.number}`)
				.then((response) => {
					this.isActiveToolTip = response.data.Success
					if (this.isActiveToolTip) {
						this.isActiveToolTip = true

						const infolocalStorge = JSON.parse(localStorage.eticket)
						const infoItem = []
						for (let i = 0; i < infolocalStorge.length; i++) {
							if (infolocalStorge[i].number != info.number) {
								infoItem.push(infolocalStorge[i])
							}
						}
						localStorage.eticket = JSON.stringify(infoItem)
						setTimeout(() => {
							this.isActiveToolTip = false
							this.isActiveTicket = false
							this.$router.push({ name: "Home" })
						}, 2500)
					}
				})
				.catch((error) => console.log(error))
		},
		loadTicket() {
			this.loading = true
			axios
				.post(this.settings.apiBookingBarakaTexnika + "/E_Ticket/CreateNewTicket", {
					"BranchId": this.$route.params.id,
					"DeviceType": this.eticketInfo.deviceType,
					"LanguageId": this.$route.params.lang,
					"PhoneNumber": this.eticketInfo.phone,
					"ServiceId": this.serviceId
				})
				.then((response) => {
					this.code = response.data.Code
					this.eticketInfo.number = response.data.Number
					this.eticketInfo.ticketId = response.data.TicketId
					// this.eticketInfo.validUntil = moment(response.data.ValidUntil).locale(this.$t("local")).format('MMMM D, YYYY, HH:mm:ss')
					this.eticketInfo.validUntil = response.data.ValidUntil
					this.eticketInfo.Message = response.data.Message
				})
				.catch((error) => console.log(error))
		},
	},
	created() {
		this.$i18n.locale = this.$route.params.lang
	},
	watch: {
		'$route.params.lang'() {
			this.$i18n.locale = this.$route.params.lang
			this.loadService()
		}
	},
	validations: {
		eticketInfo: {
			serviseText: {
				required,
				minLength: minLength(4),
				// minLength: minLength(7)
			},
			phone: { required, minLength: minLength(13), maxLength: maxLength(13) },
		},
	},
}
</script>

<style>
.etiket .alert {
	top: 374px;
}

.etiket .alert h1 {
	font-size: 30px;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.is-invalid {
	border-color: red !important;
}
</style>
